import { useQuery } from "@tanstack/react-query";
import { UserService } from "@/services/users/UserService";
import { TeamData } from "@/types/auth/auth";

const TEAM_DATA_KEY = (teamId: number, ownerId: string) => [
  "team-data",
  teamId,
  ownerId,
];

export const useTeamData = (teamId: number | undefined, ownerId: string | undefined) =>
  useQuery<TeamData | null>({
    queryKey: TEAM_DATA_KEY(teamId || 0, ownerId || ""),
    queryFn: () => {
      if (!teamId || !ownerId) return null;
      return UserService.getTeamData(teamId, ownerId);
    },
    enabled: !!teamId && !!ownerId,
    staleTime: 5 * 60 * 1000,
  });
